import apiFetch from '../apiFetch'

export default function (idCentro, token) {
  return apiFetch({endPoint: `EmpresaCentro/getCentroEmpresa?idCentro=` + idCentro, method: 'GET', body: null, token: token})
}
